import { useEffect } from 'react'

import { Section, Space } from '../../../../../../components/core-v2'
import Icon from '../../../../../../components/core-v2/atoms/Icon'
import IconButton from '../../../../../../components/core-v2/molecules/iconButton'
import LinkIcon from '../../../../../../components/core-v2/molecules/linkIcon'
import { useAppSelector } from '../../../../store/hooks'
import { useActions } from '../../../../store/use-actions'
import { DetailsSummary } from '../details-summary'
import { actions as rawActions } from '../existing-note-slice'
import { NoteFinder } from '../note-finder'

export const ExistingNotes = () => {
  const state = useAppSelector(state => state.existingNote)
  const noteState = useAppSelector(state => state.note)
  const actions = useActions(rawActions)

  useEffect(() => {
    const { note } = noteState
    actions.init(note)
  }, [actions, noteState])

  return (
    <>
      {state.isNoteSelected && state.note?.noteId.length > 0 && (
        <DetailsSummary
          asModal
          businessUnit={state.businessUnit}
          client={state.client}
          fees={state.fees}
          note={state.note}
        />
      )}

      {!state.isNoteSelected && (
        <Section pb={6} type="primary">
          <Section mt={6} mx={5} type="secondary">
            <Space isflex justifyContent="center" p={6}>
              <IconButton
                data-testid="search-for-note"
                disabled={false}
                icon={<Icon name="search" size="default" />}
                iconPosition="left"
                operationType="progress"
                text="Search for a note"
                onClick={() => actions.openNoteSearch()}
              />
            </Space>
          </Section>
        </Section>
      )}

      {state.isNoteSelected && (
        <Space isflex justifyContent="center" pb={6}>
          <LinkIcon
            underline
            disabled={false}
            icon={<Icon name="search" size="default" />}
            iconPosition="left"
            text="Choose another note"
            onClick={() => actions.openNoteSearch()}
          />
        </Space>
      )}

      {(state.findStatus === 'finding' || state.findStatus === 'inspecting') && (
        <NoteFinder
          state={state}
          onBackToSearch={() => actions.goBackToNoteList()}
          onInspectNote={note => actions.viewNote(note)}
          onSelectNote={() => actions.selectNote()}
          onStopFindingNote={() => actions.stopFindingNote()}
        />
      )}
    </>
  )
}
